import React, { useState } from 'react';
// import { GoogleGenerativeAI } from '@google/generative-ai';
import axios from "axios"
import Markdownkatexnew from "./Markdown.js";
// import { Ollama } from 'ollama'
// import ollama from 'ollama';
// import { useState } from 'react';

const GeminiChat = ({tittle}) => {
  const [prompt, setPrompt] = useState(`Generar 21 preguntas sobre ${tittle}, que tenga la siguiente estructura [
			{
				"prg": "¿Qué experimento mental propuso Erwin Schrödinger para ilustrar la paradoja de la superposición cuántica en la vida cotidiana?",
				"alt": [
					["El demonio de Maxwell"],
					["El gato de Schrödinger"],
					["El gemelo de Langevin"],
					["El cerebro de Boltzmann"]
				],
				"rpta": "El gato de Schrödinger"
			},
			{
				"prg": "¿Qué fenómeno físico demuestra que la luz y las partículas de materia pueden comportarse tanto como ondas como partículas?",
				"alt": [
					["La dualidad onda-partícula"],
					["El efecto Doppler"],
					["La ley de gravitación universal"],
					["El principio de conservación de la energía"]
				],
				"rpta": "La dualidad onda-partícula"
	}]`);
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  // Inicializa la API con tu clave
  // const apiKey = process.env.REACT_APP_GEMINI_API_KEY; // Reemplaza con tu clave o variable de entorno
  // const ai = new GoogleGenerativeAI({ apiKey: apiKey });


  const generarContenido = async () => {
    if (!prompt) return;
    setLoading(true);
    setResponse('');


    // const { Ollama } = await import('ollama');
    // const ollama = new Ollama();


    // const ollamaRes = await fetch('http://www.esfapa.edu.pe:11434/api/generate', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     model: 'llama3',
    //     messages: prompt,
    //     stream: false,
    //   }),
    // });
    // const data = await ollamaRes.json();
    // // res.json({ message: data.message.content });
    // console.log(data, "ai")


    await axios.post(`${process.env.REACT_APP_API_URL}/users/userCr`, { prompt })
      .then((res) => {
        setResponse(res.data.response)
        console.log(res.data.response, "ai")
        setLoading(false);
      })
      .catch((err) => {
        // toast.error(err);
        // if (err.response.status === 401) {
        // }
      })


  };

  return (
    <div className=''>
      {/*<input className="form-control" type="text" value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="Escribe tu mensaje..." />*/}
      <button className="form-control btn btn-info" onClick={generarContenido} disabled={loading}>
        {loading ? 'Pensando...' : `Enviar prompt ${tittle}`}
      </button>

      <div className=''>
        <Markdownkatexnew>
          {response}
        </Markdownkatexnew>
      </div>
    </div>
  );
};

export default GeminiChat;
